/* Vars */
const current_templatex = $("body").data("template");
let cookie_zipcode = Cookies.get("zipcode-dilmun");
let find_zip_delivery;
const changeZipCode = document.querySelector(".current-cp");

// Dom Changes
document.addEventListener(
  "click",
  function (event) {
    const remainingDropper = document.querySelector("[data-minimum-purchase]");
    const minimumPurchaseContainer = document.querySelector(
      "[data-minimum-purchase-container]"
    );
    const minimunPurchase = Number("") * 100;
    const buttontoCheckout = document.querySelector("#ProceedToCheckoutBellow");
    const mockupButton = document.querySelector("#mockup-to-checkout");
    const totalCart = cart_global.total_price;

    if (event.target.matches("body .landing-faq__question-heading")) {
      console.log("listen landing-faq__question-heading");
    }

    // If the clicked element doesn't have the right selector, bail
    if (!event.target.matches("body #storePickupApp img")) return;

    // if (!event.target.matches('body #storePickupApp img')) return;
    console.log("some delivery option clicked!");

    if (totalCart >= minimunPurchase) {
      minimumPurchaseContainer.style.display = "none";
    }

    if (mockupButton) {
      if (event.target.alt == "pickup selected") {
        minimumPurchaseContainer.style.display = "none";
        buttontoCheckout.disabled = false;
        buttontoCheckout.style.display = "block";
        mockupButton.style.display = "none";
      } else {
        const remaining = minimunPurchase - totalCart;
        if (remaining <= 0) {
          minimumPurchaseContainer.style.display = "none";
          buttontoCheckout.disabled = false;
          buttontoCheckout.style.display = "block";
          mockupButton.style.display = "none";
        } else {
          minimumPurchaseContainer.style.display = "block";
          remainingDropper.textContent = Shopify.formatMoney(remaining);
          buttontoCheckout.disabled = true;
          buttontoCheckout.style.display = "none";
          mockupButton.style.display = "block";
        }

        /*
      minimumPurchaseContainer.style.display = 'block';
      buttontoCheckout.disabled = true;
      buttontoCheckout.style.display = 'none';
      mockupButton.style.display = 'block';
      */
      }
    }

    // Don't follow the link
    // event.preventDefault();

    // Log the clicked element in the console
    console.log(event.target);
  },
  false
);

function handleChangeZipCode() {
  const modal = document.querySelector("[data-zipcode-popup]");
  // Reset previous modal status
  const initialScreen = modal.querySelector(".screen--initial");
  initialScreen.style.display = "block";
  const successScreen = modal.querySelector(".screen--success");
  successScreen.style.display = "none";
  const failScreen = modal.querySelector(".screen--fail");
  failScreen.style.display = "none";
  const zipCodeinput = modal.querySelector(".zipcode--input");
  zipCodeinput.value = "";
  // Open modal
  $("[data-zipcode-popup]").addClass("opened");
  document.querySelector("body").style.overflow = "hidden";
}

if (changeZipCode) {
  changeZipCode.addEventListener("click", handleChangeZipCode);
}

/* Functions */
function findZipDeliveryInput() {
  const element = document.querySelector("#deliveryGeoSearchField");
  if (element) {
    // console.log('Found');
    if (cookie_zipcode != undefined) {
      element.value = cookie_zipcode;
      $(".snize-exclude-input").click();
    }
    clearInterval(find_zip_delivery);
  } else {
    // console.log('Not found')
  }
}

function GetFormattedDate() {
  var todayTime = new Date();
  todayTime.setDate(todayTime.getDate() + 1);
  var month = todayTime.getMonth() + 1;
  var day = todayTime.getDate();
  var year = todayTime.getFullYear();
  return month + "/" + day + "/" + year;
}

function pad(n) {
  return n < 10 ? "0" + n : n;
}

function CountDownTimer(dt, id) {
  const elementDroppers = document.querySelectorAll("[data-counter-dropper]");
  let end = new Date(dt),
    _second = 1000,
    _minute = _second * 60,
    _hour = _minute * 60,
    _day = _hour * 24,
    timer;

  // console.log('end', end)

  function showRemaining(zap) {
    let now = new Date(),
      distance = end - now;

    // console.log('now', now)

    if (distance < 0) {
      clearInterval(timer);
      elementDroppers.forEach((element) => (element.innerHTML = "EXPIRED!"));

      return;
    }

    let days = Math.floor(distance / _day),
      hours = Math.floor((distance % _day) / _hour),
      minutes = Math.floor((distance % _hour) / _minute),
      seconds = Math.floor((distance % _minute) / _second);

    let horas = Number(pad(hours));
    let minutos = Number(pad(minutes));

    // console.log(zap)

    // document.getElementById(id).innerHTML = pad(hours) + '<span>:</span>' + pad(minutes) + '<span>:</span>' + pad(seconds);
    // document.getElementById(id).innerHTML = `Entrega: <strong>Mañana</strong>. Realiza el pedido en <strong> ${ horas } ${ horas <= 1 ? ' hora' : ' horas' } y ${ minutos } ${ minutos <= 1 ? ' minuto' : ' minutos' }</strong>`;
    elementDroppers.forEach(
      (element) =>
        (element.innerHTML = `Entrega: <strong>Mañana</strong>. Realiza el pedido en <strong> ${horas} ${
          horas <= 1 ? " hora" : " horas"
        } y ${minutos} ${minutos <= 1 ? " minuto" : " minutos"}</strong>`)
    );

    elementDroppers.forEach((element) => {
      if (element.classList.contains("product-form-counter")) {
        element.innerHTML = `Entrega: <span class="product-form-counter__value"><strong>Mañana</strong></span>.<br>Realiza el pedido en <span class="product-form-counter__value"><strong> ${horas} ${
          horas <= 1 ? " hora" : " horas"
        } y ${minutos} ${
          minutos <= 1 ? " minuto" : " minutos"
        }</strong></span>`;
      } else {
        element.innerHTML = `Entrega: <strong>Mañana</strong>. Realiza el pedido en <strong> ${horas} ${
          horas <= 1 ? " hora" : " horas"
        } y ${minutos} ${minutos <= 1 ? " minuto" : " minutos"}</strong>`;
      }
    });
  }

  // Grab endpoint to kwno the most near hours to deliver depengind products in cart
  (async () => {
    try {
      const response = await fetch(
        "https://api.zapiet.com/v4.0/delivery/locations?shop=dilmun-mexico.myshopify.com&geoSearchQuery=06000"
      );
      const data = await response.json();
      // console.log(data);
      // zapiet_deliver = data;

      // Grab cart and later product
      (async () => {
        try {
          const response = await fetch("/cart.js");
          const cart_res = await response.json();
          // console.log(cart_res);
          cart_res.items.forEach((line_item) => {
            (async () => {
              try {
                const response = await fetch(
                  `/products/${line_item.handle}.js`
                );
                const product_res = await response.json();
                // console.log(product_res);
                // console.log(product_res.tags);
              } catch (err) {
                console.error(err);
              }
            })();
          });
        } catch (err) {
          console.error(err);
        }
      })();

      timer = setInterval(showRemaining(data), 1000);
    } catch (err) {
      console.error(err);
    }
  })();
}

/**/

/* Delivery System Message */
const date_formatted = GetFormattedDate();
// CountDownTimer(`${ date_formatted } 11:59 PM`, 'counter-dropper');

/* --- --- --- --- --- --- --- --- --- --- --- */

/* Header CP populator */
if (cookie_zipcode != undefined) {
  $(".current-cp__data").html(`Tu C.P. <strong>${cookie_zipcode}</strong>`);
}

/* Store pickup Zipcode Populator */
if (current_templatex == "cart") {
  find_zip_delivery = setInterval(findZipDeliveryInput, 1000);
}

function updateRemainingValue(totalPrice) {
  const remainingDropper = document.querySelector("[data-minimum-purchase]");
  const minimumPurchaseContainer = document.querySelector(
    "[data-minimum-purchase-container]"
  );
  const minimunPurchase = Number("") * 100;
  const buttontoCheckout = document.querySelector("#ProceedToCheckoutBellow");
  const mockupButton = document.querySelector("#mockup-to-checkout");
  if (remainingDropper) {
    const remaining = minimunPurchase - totalPrice;
    if (remaining <= 0) {
      minimumPurchaseContainer.style.display = "none";
      buttontoCheckout.disabled = false;
      buttontoCheckout.style.display = "block";
      mockupButton.style.display = "none";
    } else {
      minimumPurchaseContainer.style.display = "block";
      remainingDropper.textContent = Shopify.formatMoney(remaining);
      buttontoCheckout.disabled = true;
      buttontoCheckout.style.display = "none";
      mockupButton.style.display = "block";
    }
  }
}

if (typeof cart_global != "undefined") {
  console.log(cart_global);
  updateRemainingValue(cart_global.original_total_price);
}

/* Advance add to cart on product-grid */
// $('.advance-add-cart').click(function() {
$("body").on("click", ".advance-add-cart", function (evt) {
  evt.preventDefault();
  const reference_btn = $(this);
  const quantity = parseInt($(`.quantity__input`).val()) || 1; 

  if (!$(this).hasClass("no-hide")) {
    reference_btn.hide();
  }

  $(`body #quantity--${reference_btn.data("product-id")}`).css(
    "display",
    "flex"
  );
  // Add to cart because user already click "Agregar al carrito"
  CartJS.addItem(
    reference_btn.data("variant-id"),
    quantity,
    {
      // "selling_plan": 8283828282
    },
    {
      // Define a success callback to display a success message.
      success: function (data, textStatus, jqXHR) {
        // console.log(data);
        let product = data;
        console.log(product);
        $(".cart-notify").hide();
        $(".cart-notify").css("display", "flex");
        // $("#cart-notify--product-data").html(
        //   `${product.title} (${product.quantity} ${
        //     product.quantity > 1 ? " piezas" : " pieza"
        //   })`
        // );
        $(".cart-notify__image").html(
          `<div class="cart-notify-wrapper">
            <img class="cart-notify__image" width="70" height="70" loading="lazy" src="${
              product.featured_image.url
            }">
            <div class="cart-notify__information"">
              <p>${product.title}</p>
            </div>
          </div>
          <div class="cart-notify__buttons">
            <a href="/cart"><span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="21" viewBox="0 0 22 21" fill="none">
<rect x="0.5" width="21" height="21" fill="url(#pattern0_1410_4855)"/>
<defs>
<pattern id="pattern0_1410_4855" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1410_4855" transform="scale(0.0166667)"/>
</pattern>
<image id="image0_1410_4855" width="60" height="60" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE+klEQVR4nO2aXWgdVRCAZ+zPg9aK1QcRC4qCVlFqg/UXUmyyM/c21L/GB/HFP1CboiBWn2zf1FbrH/49iBZ9imCl1Hp3ZsNFjSIY7YuK1B9UNLX+UGuTRps2kbNra+45m+zeezfJbrkf7Mvlzpwz58yZmZ2zAC1atGjR4nijt3sOCBEKbUGlD1D4F1T6O3yE9qBSPyo9BX7p2vC/denllUY21BHp+l+v8Pso/KQZuy69DTPQNg/E60HlQVQeT/UIfW9koNo+d0q9yutQ+YfUepV/Bp/WhrLTQlAqofLXdUzINvwz8MtLHb3Kl6LSrob1Ku8OdzxbY2k9Kh1pYlL/Gc2HQOi+Y3qF70fh0ab1Kh0GpQczsRWFXp5kkP2o9DqodxNUvAtgJy+E7V0nQh+fa35DoddQ6OAkhj+Owpsm8YSDKLQVAl4DFe+8UKfRLeUl5jczZjR2rN6XMthZtg01QWQzVLxFifLV8hmo/CIKj6XY/TFUesHIJOrVlaeZ4IVK/9h6Gt/pwJxZy42F9oDSlXXriiL6X1O45P6GzmGfd1WUISz3rlvXQNs8J0AZY9+ls6FRfK8NlffGGLwXAlrWuN7Oc1yjeXd90VvC1FPjxg3trE1Ay1BpeILe4aaMPYpfutp2b1C+N51wtX2um2dpM2SFcDcq/xHmUfW6slIbFSs1HvlTuuLEnDf7fKUJULNNtet0O06AUkeiXFQu1qzUVigIKPSGFfk3JQuZ2njiKpl8WBSEbra8871Emahgn2CwKSqKgpSXWNF6MFEmKiwmGNy/+mQoCtpxiuXSI4kytWmDx6HavgCKQrV9geXSw4kyqPxdjcF9dD4U1aWFvkmUQeGPihu0whw/cYf7E2VQ6HlrlV6BgoDKr1pzfzZZSuhGp9bt7Z4Peae3ez4q/VrrnaXrkwUr3iL7pRzUuwXyjs+3WhH6EOxYdWoqWVR6yzoLH0POQaVPLHd+M720z577Yp1doZ85Stc58zUd09SMA6LSl5aLfD4zrdE66e2eY+bmzHUcsD5FbvAaD9uiecN5d08brGJA4Q+dV8UqnwV5QTrOROU/nXhT9+4eRfgKtz1L2yEPhMeOd1hzOwx++fKm9KLy047LCN0Ns41Pa+15hdcwzSvuPMmur03vGAK+EGaLPrrI6XkLfWvmms0AgbfcJHJrNb9KndizZCcvRKEvrLmMmpZttgMpPxzjQjLlJdl0pCCld9waIaNrlho2bDjBBCzHaOXnYIYwY8Us+tuNR+VUL9juTR8o3wPTTcB3uItNu6a/QVHxFpueslOo++xN25im1LVjiOlrz1hNEJgbBB5y2ilKKzIfK7o/OuBmCW85zChKq0yit1Z9CJSvyWwMU/g4l3B0BHy+AWYFDT9TsIII7TO3+pl4kdA+t+jxemBWEX4oxujfIOBLGtbpl5ei8O/uSwGth1ygtDF+pxu4cVS+LNZY4UcgT6DSozE5eggCrzO1EqUVsRfnQlsgj6B9ZRmlrBEQWp2qayE8ErNoT0CukZgzHX5lw+smlyndFf81Dz0GhUC8ntgPWYSfMSXqsf+ZkjD2/PMYiPcAFAqhO2PytDmP28IKyVRsQttijB0F5duhkPim+znJN1Vxj/CBXHdHU6Gli1H5xxQGD5ovfeC4oGLclz+dwtiBXDUHMyH8NNi7DZX8sNMYlY0V81su+90tWrRo0QJmnn8BA0BQDILwdXYAAAAASUVORK5CYII="/>
</defs>
</svg></span>Ver carrito (${product.quantity} ${
            product.quantity > 1 ? " piezas" : " pieza"
          })</a>
          <a href="/cart#shopify-section-template--18337901543679__doos_cart_zapier_gyatWt">Pagar ahora</a>
          </div>`
        );
        $(`#input--${reference_btn.data("product-id")}`).val(data.quantity);
        setTimeout(function () {
          $(".cart-notify").fadeOut();
        }, 3000);

        // inline product page notification
        if (
          $(`#inline-notification--${reference_btn.data("product-id")}`).length
        ) {
          $(`#inline-notification--${reference_btn.data("product-id")}`).html(
            `Agregaste <strong>${product.title}</strong> a tu carrito`
          );
        }
        if (cookie_zipcode) {
          intervals.map((interval) => clearInterval(interval));
          shippingDelivery();
          if (dilmunProductHandle) {
            shippingDeliveryProductPage(dilmunProductHandle);
          }
        }
        renderCartComponents();
      },

      // Define an error callback to display an error message.
      error: function (jqXHR, textStatus, errorThrown) {},
    }
  );
});

function renderCartComponents() {
  fetch("/cart")
    .then((response) => response.text())
    .then((html) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, "text/html");
      let productsList = doc.querySelector(".list-products");
      let productsListWrapper = document.querySelector(
        ".cart-products-wrapper"
      );
      if (productsListWrapper) productsListWrapper.innerHTML = "";
      productsListWrapper.append(productsList);
      let cartTopBar = doc.querySelector(".btn-wrapper.img-end");
      let cartTopBarWrapper = document.querySelector(
        "[data-cart-top-bar-wrapper]"
      );
      if (cartTopBarWrapper) cartTopBarWrapper.innerHTML = "";
      cartTopBarWrapper.append(cartTopBar);
      let cartBottomBar = doc.querySelector("[data-cart-bottom-bar-content]");
      let cartBottomBarWrapper = document.querySelector(
        "[data-cart-bottom-bar-wrapper]"
      );
      if (cartBottomBarWrapper) cartBottomBarWrapper.innerHTML = "";
      cartBottomBarWrapper.append(cartBottomBar);
      let minimumPurchase = doc.querySelector(
        "[data-minimum-purchase-container] p"
      );
      let minimumPurchaseWrapper = doc.querySelector(
        "[data-minimum-purchase-container]"
      );
      if (minimumPurchaseWrapper) minimumPurchaseWrapper.innerHTML = "";
      minimumPurchaseWrapper.append(minimumPurchase);
      cartLogic();
    })
    .catch((err) => console.error("Failed to fetch page: ", err));
}

$(document).on("click", ".quick-add-tocart", function (e) {
  e.preventDefault();
  const reference_btn = $(this);
  CartJS.addItem(
    reference_btn.data("variant-id"),
    1,
    {},
    {
      // Define a success callback to display a success message.
      success: function (data, textStatus, jqXHR) {
        // console.log(data);
        let product = data;
        $(".cart-notify").hide();
        $(".cart-notify").css("display", "flex");
        $("#cart-notify--product-data").html(
          `${product.title} (${product.quantity} ${
            product.quantity > 1 ? " piezas" : " pieza"
          })`
        );
        $(".cart-notify__image").html(
          `<img src="${product.featured_image.url}">`
        );
        $(`#input--${reference_btn.data("product-id")}`).val(data.quantity);
        setTimeout(function () {
          $(".cart-notify").fadeOut();
        }, 3000);

        // inline product page notification
        if (
          $(`#inline-notification--${reference_btn.data("product-id")}`).length
        ) {
          $(`#inline-notification--${reference_btn.data("product-id")}`).html(
            `Agregaste <strong>${product.title}</strong> a tu carrito`
          );
        }
        if (cookie_zipcode) {
          intervals.map((interval) => clearInterval(interval));
          shippingDelivery();
          if (dilmunProductHandle) {
            shippingDeliveryProductPage(dilmunProductHandle);
          }
        }
      },

      // Define an error callback to display an error message.
      error: function (jqXHR, textStatus, errorThrown) {},
    }
  );
});

// $('.add-cart--quantity').click(function() {
// $(document).on("click", '.add-cart--quantity').click(function() {
$(document).on("click", ".add-cart--quantity", function () {
  const btn = $(this);
  const input = $(`body #input--${btn.data("target-input")}`);
  const maxValue = Number(document.querySelector(`body #input--${btn.data("target-input")}`).getAttribute('max'));
  const variant_id = btn.data("variant-id");
  let quantity_input = input.val() * 1;
  let inline_notification = $(
    `body #inline-notification--${btn.data("target-input")}`
  );
  switch (btn.data("kind-controller")) {
    case "minus":
      if (quantity_input > 1) {
        quantity_input -= 1;
        // CartJS.updateItemById(variant_id, quantity_input)
        CartJS.updateItemById(
          variant_id,
          quantity_input,
          {},
          {
            success: function (data, textStatus, jqXHR) {
              // console.log(data);
              $("#cart-count .count").html(data.item_count);
              renderCartComponents();
            },
            error: function (jqXHR, textStatus, errorThrown) {},
          }
        );
      }
      break;
    case "plus":
      if( maxValue > quantity_input ){
        quantity_input += 1;
        // CartJS.updateItemById(variant_id, quantity_input)
        CartJS.updateItemById(
          variant_id,
          quantity_input,
          {},
          {
            success: function (data, textStatus, jqXHR) {
              // console.log(data);
              $("body #cart-count .count").html(data.item_count);
              renderCartComponents();
            },
            error: function (jqXHR, textStatus, errorThrown) {},
          }
        );
      }
      break;
    default:
      break;
  }

  input.val(quantity_input);
});

$(document).on("cart.requestComplete", (event, cart) => {
  // console.log('Complete');
  updateRemainingValue(cart.original_total_price);
});

// Collection sidebar filter
function handleMenuVisibility() {
  const wrapper = this.closest(".collection-sidebar-list__li");
  const innerMenu = wrapper.querySelector(
    ".collection-sidebar-list-third-level"
  );
  const arrow = this.querySelector("svg");
  if (innerMenu.offsetHeight > 0) {
    arrow.style.transform = "rotate(-90deg)";
    innerMenu.style.maxHeight = 0;
  } else {
    arrow.style.transform = "rotate(0)";
    innerMenu.style.maxHeight = `${innerMenu.scrollHeight}px`;
  }
}

const sidebarFilterDropDownTriggers = document.querySelectorAll(
  ".collection-sidebar-trigger-inner-menu"
);
if (sidebarFilterDropDownTriggers) {
  sidebarFilterDropDownTriggers.forEach((element) =>
    element.addEventListener("click", handleMenuVisibility)
  );
}

function activeSidebarFilterDropdowns() {
  const openSidebarDropDowns = document.querySelector(
    ".collection-sidebar-list__third-level--active"
  );
  if (openSidebarDropDowns) {
    openSidebarDropDowns.parentElement.parentElement.parentElement
      .querySelector(".collection-sidebar-trigger-inner-menu")
      .click();
  }
}

activeSidebarFilterDropdowns();

function openSidebarFilterVisibility() {
  window.scroll({
    top: 0,
    behavior: "smooth",
  });
  const sidebar = document.querySelector(".collection-sidebar");
  const body = document.querySelector("body");
  const overlay = document.querySelector(".DrawerOverlay");
  overlay.classList.add("DrawerOverlay--active");
  sidebar.classList.add("collection-sidebar--open");
  body.style.overflow = "hidden";
  activeSidebarFilterDropdowns();
}

function closeSidebarFilterVisibility() {
  const sidebar = document.querySelector(".collection-sidebar");
  const body = document.querySelector("body");
  const overlay = document.querySelector(".DrawerOverlay");
  overlay.classList.remove("DrawerOverlay--active");
  sidebar.classList.remove("collection-sidebar--open");
  body.style.overflow = "";
}

const sidebarFilterTrigger = document.querySelector(
  ".collection-filter-trigger"
);
if (sidebarFilterTrigger) {
  sidebarFilterTrigger.addEventListener("click", openSidebarFilterVisibility);
}

const overlay = document.querySelector(".DrawerOverlay");
if (overlay) {
  overlay.addEventListener("click", closeSidebarFilterVisibility);
}

const closeSidebar = document.querySelector(".collection-sidebar__close svg");
if (closeSidebar) {
  closeSidebar.addEventListener("click", closeSidebarFilterVisibility);
}

function checkSidebarVisibility() {
  if (
    sidebarFilter.classList.contains("collection-sidebar--open") &&
    window.innerWidth > 767
  ) {
    closeSidebarFilterVisibility();
  }
}

const sidebarFilter = document.querySelector(".collection-sidebar");
if (sidebarFilter) {
  window.addEventListener("resize", checkSidebarVisibility);
}

function landingPages() {
  console.log("landing pages INIT");
  function placeZIPCode() {
    const zipCodeInput = document.querySelector(".shipping-code__input");
    const zipCodeDrops = document.querySelectorAll("[data-zip-code-drop]");
    const updateZipCode = document.querySelector(".shipping-code__label");
    if (cookie_zipcode) {
      if (zipCodeInput) {
        zipCodeInput.value = cookie_zipcode;
      }
      if (zipCodeDrops) {
        zipCodeDrops.forEach((drop) => (drop.textContent = cookie_zipcode));
      }
    }
    if (updateZipCode) {
      updateZipCode.addEventListener("click", () => {
        handleChangeZipCode();
      });
    }
  }

  placeZIPCode();

  function handleFaqGroup() {
    const container = this.closest(".landing-faq__group-container");
    const questions = container.querySelector(".landing-faq__inner-wrapper");
    this.classList.toggle("landing-faq__item--active");
    questions.classList.toggle("landing-faq__inner-wrapper--active");
  }

  function handleFaqQuestion() {
    const container = this.closest("[data-question-container]");
    const answer = container.querySelector(".landing-rich-text--answer");
    this.classList.toggle("landing-faq__question-heading--active");
    answer.classList.toggle("landing-rich-text--answer--active");
  }

  const faqGroups = document.querySelectorAll(".landing-faq__item");
  if (faqGroups) {
    faqGroups.forEach((group) =>
      group.addEventListener("click", handleFaqGroup)
    );
  }

  const faqQuestions = document.querySelectorAll(
    ".landing-faq__question-heading"
  );
  if (faqQuestions) {
    console.log("adding event click to faqs options");
    faqQuestions.forEach((item) =>
      item.addEventListener("click", handleFaqQuestion)
    );
  }
}

landingPages();

document.addEventListener("shopify:section:load", (e) => {
  landingPages();
});

const megaMenu = document.querySelector(".main-menu.no-mobile.full");
const mainContent = document.querySelector(".main-content");
// if (megaMenu && mainContent) {
//   document.addEventListener("scroll", () => {
//     if (window.innerWidth > 767) {
//       const header = document.querySelector(".header-desktop");
//       const shippingBar = document.querySelector("#shipping-bar");
//       if (window.scrollY < header.offsetHeight) {
//         megaMenu.style.position = "relative";
//         megaMenu.style.top = "0";
//         mainContent.style.margin = "0";
//       } else if (window.scrollY > header.offsetHeight) {
//         megaMenu.style.position = "fixed";
//         if (shippingBar) {
//           megaMenu.style.top = `${shippingBar.offsetHeight}px`;
//         } else {
//           megaMenu.style.top = "0";
//         }
//         mainContent.style.margin = "60px 0 0";
//       }
//     } else {
//       megaMenu.style.position = "relative";
//       megaMenu.style.top = "0";
//       mainContent.style.margin = "0";
//     }
//   });
// }

window.dispatchEvent(new Event("resize"));

/* Shipping delivery */
const weekdays = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

async function fetchProducts(handles) {
  const products = [];
  if (handles.length === 0) {
    return products;
  }
  for (const handle of handles) {
    const response = await fetch(`/products/${handle}.js`);
    const product = await response.json();
    products.push(product);
  }
  return products;
}

async function fetchZapiet() {
  const cookieZipCode = Cookies.get("zipcode-dilmun");
  if (cookieZipCode) {
    const response = await fetch(
      `https://api.zapiet.com/v4.0/delivery/locations?shop=dilmun-mexico.myshopify.com&geoSearchQuery=${cookieZipCode}`
    );
    const data = await response.json();
    return data;
  }
}

const dateOptions = { weekday: "long", month: "short", day: "numeric" };

let countDownInterval;
const intervals = [];

function printDeliveryDate(
  zapierData,
  weekDay,
  deliveryDateString,
  isTomorrow,
  deliveryDateObject,
  isProduct
) {
  let blackouts = zapierData.delivery.blackouts;
  let deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
  let breakpoint = deliveryDayData.breakpoint;
  let breakpointHour = breakpoint.split(":")[0];
  let breakpointMinutes = breakpoint.split(":")[1];
  let breakpointTimeLimit = new Date().setHours(
    breakpointHour,
    breakpointMinutes,
    "00"
  );
  let nextDayCount = 1;
  let nextWeekDayCount = 1;
  let nextDayWhileLoop = 1;
  let nextAvailableDay = new Date(deliveryDateObject);

  blackouts.map((date) => {
    const blackoutDate = new Date(
      new Date(date).setDate(new Date(date).getDate() + 1)
    ).toLocaleDateString("es-ES", dateOptions);
    const nextAvailableDayTime = new Date(
      new Date(nextAvailableDay)
    ).toLocaleDateString("es-ES", dateOptions);
    if (blackoutDate === nextAvailableDayTime) {
      isTomorrow = false;
      nextAvailableDay = new Date(nextAvailableDay).setDate(
        new Date(nextAvailableDay).getDate() + nextDayWhileLoop
      );
      weekDay = weekdays[new Date(nextAvailableDay).getDay()];
      deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
      breakpoint = deliveryDayData.breakpoint;
      deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
        "es-ES",
        dateOptions
      );
      while (!deliveryDayData.slots.enabled) {
        // Get the next week day
        nextAvailableDay = new Date(nextAvailableDay).setDate(
          new Date(nextAvailableDay).getDate() + nextDayWhileLoop
        );
        weekDay = weekdays[new Date(nextAvailableDay).getDay()];
        deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
        breakpoint = deliveryDayData.breakpoint;
        deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
          "es-ES",
          dateOptions
        );
      }
    }
  });

  // Validate Zapiet shipping availability
  while (!deliveryDayData.slots.enabled) {
    isTomorrow = false;
    // Get the next week day
    nextAvailableDay = new Date(deliveryDateObject).setDate(
      new Date(deliveryDateObject).getDate() + nextWeekDayCount
    );
    weekDay = weekdays[new Date(nextAvailableDay).getDay()];
    deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
    breakpoint = deliveryDayData.breakpoint;
    breakpointHour = breakpoint.split(":")[0];
    breakpointMinutes = breakpoint.split(":")[1];
    breakpointTimeLimit = new Date().setHours(
      breakpointHour,
      breakpointMinutes,
      "00"
    );
    deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
      "es-ES",
      dateOptions
    );
    if (!deliveryDayData.slots.enabled) {
      nextWeekDayCount++;
    }
    blackouts.map((date) => {
      const blackoutDate = new Date(
        new Date(date).setDate(new Date(date).getDate() + 1)
      ).toLocaleDateString("es-ES", dateOptions);
      const nextAvailableDayTime = new Date(
        new Date(nextAvailableDay)
      ).toLocaleDateString("es-ES", dateOptions);
      if (blackoutDate === nextAvailableDayTime) {
        isTomorrow = false;
        nextAvailableDay = new Date(nextAvailableDay).setDate(
          new Date(nextAvailableDay).getDate() + nextDayWhileLoop
        );
        weekDay = weekdays[new Date(nextAvailableDay).getDay()];
        deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
        breakpoint = deliveryDayData.breakpoint;
        deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
          "es-ES",
          dateOptions
        );
      }
    });
  }

  // Update the count down every 1 second
  countDownInterval = setInterval(function () {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = breakpointTimeLimit - now;

    // If the count down is over
    if (distance < 0) {
      let nextDate = new Date(nextAvailableDay).setDate(
        new Date(nextAvailableDay).getDate() + nextDayCount
      );
      isTomorrow = false;
      weekDay = weekdays[new Date(nextDate).getDay()];
      deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
      breakpoint = deliveryDayData.breakpoint;
      nextAvailableDay = new Date(nextAvailableDay).setDate(
        new Date(nextAvailableDay).getDate() + nextDayCount
      );

      blackouts.map((date) => {
        const blackoutDate = new Date(
          new Date(date).setDate(new Date(date).getDate() + 1)
        ).toLocaleDateString("es-ES", dateOptions);
        const nextAvailableDayTime = new Date(
          new Date(nextAvailableDay)
        ).toLocaleDateString("es-ES", dateOptions);
        if (blackoutDate === nextAvailableDayTime) {
          nextAvailableDay = new Date(nextAvailableDay).setDate(
            new Date(nextAvailableDay).getDate() + nextDayWhileLoop
          );
          weekDay = weekdays[new Date(nextAvailableDay).getDay()];
          deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
          breakpoint = deliveryDayData.breakpoint;
          deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
            "es-ES",
            dateOptions
          );
          while (!deliveryDayData.slots.enabled) {
            // Get the next week day
            nextAvailableDay = new Date(nextAvailableDay).setDate(
              new Date(nextAvailableDay).getDate() + nextDayWhileLoop
            );
            weekDay = weekdays[new Date(nextAvailableDay).getDay()];
            deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
            breakpoint = deliveryDayData.breakpoint;
            deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
              "es-ES",
              dateOptions
            );
          }
        }
      });

      while (!deliveryDayData.slots.enabled) {
        // Get the next week day
        nextAvailableDay = new Date(nextAvailableDay).setDate(
          new Date(nextAvailableDay).getDate() + nextDayWhileLoop
        );
        weekDay = weekdays[new Date(nextAvailableDay).getDay()];
        deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
        breakpoint = deliveryDayData.breakpoint;
        deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
          "es-ES",
          dateOptions
        );
        blackouts.map((date) => {
          const blackoutDate = new Date(
            new Date(date).setDate(new Date(date).getDate() + 1)
          ).toLocaleDateString("es-ES", dateOptions);
          const nextAvailableDayTime = new Date(
            new Date(nextAvailableDay)
          ).toLocaleDateString("es-ES", dateOptions);
          if (blackoutDate === nextAvailableDayTime) {
            isTomorrow = false;
            nextAvailableDay = new Date(nextAvailableDay).setDate(
              new Date(nextAvailableDay).getDate() + nextDayWhileLoop
            );
            weekDay = weekdays[new Date(nextAvailableDay).getDay()];
            deliveryDayData = zapierData.delivery[weekDay.toLowerCase()];
            breakpoint = deliveryDayData.breakpoint;
            deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
              "es-ES",
              dateOptions
            );
          }
        });
      }

      breakpointTimeLimit = new Date().setHours(
        breakpointHour,
        breakpointMinutes,
        "00"
      );
      deliveryDateString = new Date(nextAvailableDay).toLocaleDateString(
        "es-ES",
        dateOptions
      );
      nextDayCount++;
    }

    // Time calculations for days, hours, minutes and seconds
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (isProduct) {
      // Output the result - Product page
      const shippingCountdownProduct = document.querySelector(
        "[data-counter-dropper]"
      );
      if (shippingCountdownProduct) {
        shippingCountdownProduct.innerHTML = `Entrega: <span class="product-form-counter__value"><strong>${
          isTomorrow ? `mañana` : deliveryDateString
        }</strong></span><br>Si realizas el pedido en:  <span class="product-form-counter__value"><strong>${
          hours > 0
            ? `${hours === 1 ? `${hours} hora` : `${hours} horas`} y ${
                minutes === 1 ? `${minutes} minuto` : `${minutes} minutos`
              }`
            : `${
                minutes > 0
                  ? `${
                      minutes === 1 ? `${minutes} minuto` : `${minutes} minutos`
                    } y ${
                      seconds === 1
                        ? `${seconds} segundo`
                        : `${seconds} segundos`
                    }`
                  : `${
                      seconds > 0
                        ? `${
                            seconds === 1
                              ? `${seconds} segundo`
                              : `${seconds} segundos`
                          }`
                        : `0 segundos`
                    }`
              }`
        }</strong></span>`;
      }
    } else {
      // Output the result - Top bar
      const countDownResultDropper = document.querySelector(
        "[data-dilmun-counter-dropper]"
      );
      if (countDownResultDropper) {
        countDownResultDropper.textContent = `Entrega ${
          isTomorrow ? `mañana` : deliveryDateString
        } si realizas el pedido en ${
          hours > 0
            ? `${hours === 1 ? `${hours} hora` : `${hours} horas`} y ${
                minutes === 1 ? `${minutes} minuto` : `${minutes} minutos`
              }`
            : `${
                minutes > 0
                  ? `${
                      minutes === 1 ? `${minutes} minuto` : `${minutes} minutos`
                    } y ${
                      seconds === 1
                        ? `${seconds} segundo`
                        : `${seconds} segundos`
                    }`
                  : `${
                      seconds > 0
                        ? `${
                            seconds === 1
                              ? `${seconds} segundo`
                              : `${seconds} segundos`
                          }`
                        : `0 segundos`
                    }`
              }`
        }`;
      }
    }
  }, 1000);
  intervals.push(countDownInterval);
}

function deliveryDates(products, isProduct) {
  // Delivery scenarios
  let deliveryTomorrow = false;
  let deliveryInThreeDays = false;
  let deliveryInSixDays = false;
  let deliveryInFifteenDays = false;
  let isTomorrow = false;

  let deliveryTags = [];

  if (products.length === 0) {
    deliveryTags.push("ENTREGA12HRS");
  } else {
    products.map((product) => {
      product.tags.map((tag) => {
        switch (tag) {
          case "ANTICIPACION15DIAS":
            deliveryTags.push("ANTICIPACION15DIAS");
            break;
          case "ANTICIPACION6DIAS":
            deliveryTags.push("ANTICIPACION6DIAS");
            break;
          case "ANTICIPACION3DIAS":
            deliveryTags.push("ANTICIPACION3DIAS");
            break;
          case "ENTREGA24HRS":
          case "ENTREGA12HRS":
            deliveryTags.push("ENTREGA24HRS");
            deliveryTags.push("ENTREGA12HRS");
            break;
          default:
            break;
        }
      });
    });
  }

  if (deliveryTags.includes("ANTICIPACION15DIAS")) {
    deliveryInFifteenDays = true;
  } else if (deliveryTags.includes("ANTICIPACION6DIAS")) {
    deliveryInSixDays = true;
  } else if (deliveryTags.includes("ANTICIPACION3DIAS")) {
    deliveryInThreeDays = true;
  } else if (
    deliveryTags.includes("ENTREGA24HRS") ||
    deliveryTags.includes("ENTREGA12HRS")
  ) {
    deliveryTomorrow = true;
    isTomorrow = true;
  }

  let weekDay = "";
  let deliveryDate = new Date();
  let continueWithCountdown = false;

  if (deliveryInFifteenDays) {
    deliveryDate.setDate(new Date().getDate() + 15);
    weekDay = weekdays[deliveryDate.getDay()];
    continueWithCountdown = true;
  } else if (deliveryInSixDays) {
    deliveryDate.setDate(new Date().getDate() + 6);
    weekDay = weekdays[deliveryDate.getDay()];
    continueWithCountdown = true;
  } else if (deliveryInThreeDays) {
    deliveryDate.setDate(new Date().getDate() + 3);
    weekDay = weekdays[deliveryDate.getDay()];
    continueWithCountdown = true;
  } else if (deliveryTomorrow) {
    deliveryDate.setDate(new Date().getDate() + 1);
    weekDay = weekdays[deliveryDate.getDay()];
    continueWithCountdown = true;
  }

  if (continueWithCountdown) {
    const deliveryDateString = deliveryDate.toLocaleDateString(
      "es-ES",
      dateOptions
    );
    fetchZapiet()
      .then((data) =>
        printDeliveryDate(
          data,
          weekDay,
          deliveryDateString,
          isTomorrow,
          deliveryDate,
          isProduct
        )
      )
      .catch((err) => console.log("Error", err));
  } else {
    shippingBarDefaultMessage();
  }
}

function deliveryInfo(data, isProduct = false) {
  const cartLineItems = data.items;
  const itemsHandles = [];
  cartLineItems.map((item) => itemsHandles.push(item.handle));
  fetchProducts(itemsHandles)
    .then((products) => deliveryDates(products, isProduct))
    .catch((err) => console.log("Error", err));
}

async function topBarShippingBarTrigger() {
  const response = await fetch("/cart.js");
  return response.json();
}

function shippingBarDefaultMessage() {
  const countDownShippingElement = document.querySelector(
    "[data-dilmun-counter-dropper]"
  );
  if (countDownShippingElement) {
    const shippingMessage =
      countDownShippingElement.dataset.dilmunShippingBarMessage;
    countDownShippingElement.textContent = shippingMessage;
  }
}

if (cookie_zipcode) {
  topBarShippingBarTrigger().then((data) => {
    if (data.items.length > 0) {
      shippingDelivery(data);
    } else {
      if (display_counter_only_when_cart_has_products) {
        shippingBarDefaultMessage();
      } else {
        shippingDelivery(data);
      }
    }
  });
} else {
  shippingBarDefaultMessage();
}

function shippingDelivery(cartData) {
  if (cartData) {
    deliveryInfo(cartData);
  } else {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => deliveryInfo(data));
  }
}

function shippingDeliveryProductPage(productHandle) {
  fetch(`/products/${productHandle}.js`)
    .then((response) => response.json())
    .then((data) => {
      let isProduct = true;
      const productDataArray = {
        items: [],
      };
      productDataArray.items.push(data);
      deliveryInfo(productDataArray, isProduct);
    });
}

const productPageContainer = document.querySelector(".product-page");
let dilmunProductHandle;
if (productPageContainer) {
  dilmunProductHandle = productPageContainer.dataset.productHandle;
  if (cookie_zipcode) {
    shippingDeliveryProductPage(dilmunProductHandle);
  }
}

/* Scrollify by https://minionmade.github.io/scrollify/ */
document.addEventListener("DOMContentLoaded", function () {
  var endlessScroll = new Ajaxinate({
    loadingText: "Cargando...",
  });
});

// carousel-collection

class CarouselSlider extends HTMLElement {
    constructor() {
        super();
        this.currentIndex = 0;
        this.size = parseInt(this.getAttribute('size')) || 3;
        this.mobileSize = parseInt(this.getAttribute('mobile-size')) || 1;
        this.cards = Array.from(this.children);
        this.itemsPerViewport = this.size; // default to desktop size initially
        this.updateSize();
        this.render();
    }

    connectedCallback() {
        this.createControls();
        this.updateSize();
        window.addEventListener('resize', () => this.updateSize());
    }

    createControls() {
        const controls = document.createElement('div');
        controls.className = 'carousel-controls';
        const prevButton = document.createElement('button');
        prevButton.className = 'carousel-button';
        prevButton.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 1L1 5L5.5 9" stroke="#452B1A" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
        prevButton.onclick = () => this.prev();
        const nextButton = document.createElement('button');
        nextButton.className = 'carousel-button';
        nextButton.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5.5 5L1 9" stroke="#452B1A" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
        nextButton.onclick = () => this.next();
        controls.appendChild(prevButton);
        controls.appendChild(nextButton);
        this.appendChild(controls);
    }

    updateSize() {
        const isMobile = window.innerWidth < 768;
        this.itemsPerViewport = isMobile ? this.mobileSize : this.size;
        this.style.setProperty('--size', this.itemsPerViewport);
        this.render();
    }

    render() {
      const firstCard = this.cards[0];
      const cardWidth = firstCard.offsetWidth;
      const offset = -this.currentIndex * cardWidth;
      this.cards.forEach(card => {
          card.style.transform = `translateX(${offset}px)`;
      });
    }

    prev() {
        const maxIndex = this.cards.length - this.itemsPerViewport;
        this.currentIndex = Math.max(this.currentIndex - this.itemsPerViewport, 0);
        this.render();
    }

    next() {
        const maxIndex = this.cards.length - this.itemsPerViewport;
        this.currentIndex = Math.min(this.currentIndex + this.itemsPerViewport, maxIndex);  
        this.render();
    }
}

customElements.define('carousel-slider', CarouselSlider);


